import { Descriptions } from 'antd';
import type IBCDescriptionsProps from './entities/IProps';

const BCDescriptions: React.FC<IBCDescriptionsProps> = (props: IBCDescriptionsProps) => (
	<Descriptions {...props} />
);

export { IBCDescriptionsProps };
export default BCDescriptions;
